import React from "react";
import { FlexibleCardLayoutSection as FlexibleCardLayoutSectionType } from "@/types/dto/flexible-card-layout-section";
import FlexibleCardLayoutClient from "./flexible-card-layout-client";

export interface FlexibleCardLayoutProps {
  section: FlexibleCardLayoutSectionType;
  moduleRankingPosition?: string;
}

const FlexibleCardLayout: React.FC<FlexibleCardLayoutProps> = ({
  section,
  moduleRankingPosition
}) => <FlexibleCardLayoutClient section={section} moduleRankingPosition={moduleRankingPosition} />;

export default FlexibleCardLayout;
